var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.headerShow)?[_c('svg',{attrs:{"id":"map","width":"800","height":"600"}})]:[_c('svg',{staticStyle:{"width":"100%"},attrs:{"id":"map","height":"600"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }